var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgExclamationOutline = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 29 29"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.417,
  d: "M14.5 10.877v2.416m0 4.834h.011M6.129 22.96H22.87c1.86 0 3.023-2.014 2.093-3.625l-8.372-14.5c-.93-1.61-3.255-1.61-4.185 0l-8.372 14.5c-.93 1.611.232 3.625 2.093 3.625"
})));
export default SvgExclamationOutline;